/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        $('.navbar-toggle').click(function () {
          $(this).toggleClass('open');
          $('body').toggleClass('open');
        });

        // Headroom
        var headroomInstance = $('header').data('headroom');
        if (headroomInstance && typeof headroomInstance.destroy === 'function') {
          headroomInstance.destroy();
        }

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // Flickity
        $('.main-gallery').flickity({
          imagesLoaded: true,
          autoPlay: 4500,
          pageDots: false
        });

        // Twitter
        var lifecyclesTweets = {
          "profile": { "screenName": 'lifecyclesprjct' },
          "domId": 'twitter-widget',
          "maxTweets": 2,
          "enableLinks": true,
          "showImages": false,
          "showUser": false,
          "showInteraction": false,
          "showRetweet": false
        };
        if (document.getElementById('twitter-widget')) {
          twitterFetcher.fetch(lifecyclesTweets);
        }
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // Close the modal
        $('#menu-item-15 .sub-menu a').click(function () {
          $('body').toggleClass('open');
          $('.navbar-toggle').toggleClass('open');
          $('.navbar-collapse').toggleClass('in');
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
